import { createContext } from 'react'

export const ScreenContext = createContext({ isSmallScreen: false })

export default ScreenContext

ScreenContext.displayName = 'ScreenContext'
